import { GalleryVerticalEnd } from "lucide-react";

import { useDSDFiles } from "@/hooks/use-dsd-files";
import { DsdFileStatus } from "@/types/dsd";
import { useWorkbookId } from "@/hooks/use-workbook";
import { SidebarHeader } from "@/styles/ui/sidebar";
import { getFormattedTimeWithDate } from "@/utils/time";

export const SidebarWorkspaceHeader = () => {
  const { data: workbookId } = useWorkbookId();
  const { data, isLoading, isError } = useDSDFiles({
    status: DsdFileStatus.DSD_ANALYZED,
  });

  if (isLoading || isError || data === undefined || !workbookId) {
    return null;
  }

  const workbook = data.find((workspace) => workspace.id === workbookId);

  return (
    <SidebarHeader className="flex items-center p-2 h-16">
      <div className="flex p-2 w-60 h-12 items-center gap-2">
        <span className="flex items-center justify-center h-8 w-8 bg-[#171717] rounded-lg [&_svg]:text-white [&_svg]:size-4">
          <GalleryVerticalEnd />
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-left truncate">
            {workbook?.label ?? ""}
          </p>
          <p className="text-xs text-left">
            {workbook?.createdAt
              ? getFormattedTimeWithDate(new Date(workbook?.createdAt))
              : ""}
          </p>
        </div>
      </div>
    </SidebarHeader>
  );
};
